<template>
    <el-dialog
            :title="addTextConfig.title"
            :visible.sync="dialogVisible"
            :append-to-body="true"
            :close-on-click-modal="false"
            @close="reset"
            width="700px">

        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
            <span style="margin-left: 100px; color: #0072E0; font-size: 12px">{{ formTextConfig.tip1 }}</span>
            <el-form-item :label="formTextConfig.username" prop="username">
                <el-input v-model="form.username" :placeholder="formTextConfig.tip2"></el-input>
            </el-form-item>
            <el-form-item :label="formTextConfig.realname" prop="realname">
                <el-input v-model="form.realname"></el-input>
            </el-form-item>
            <el-form-item :label="formTextConfig.phone" prop="phone">
                <el-input v-model="form.phone"></el-input>
            </el-form-item>
            <el-form-item :label="formTextConfig.email" prop="email">
                <el-input v-model="form.email"></el-input>
            </el-form-item>
            <el-form-item :label="formTextConfig.defaultPwd">
                <el-input :value="formTextConfig.defaultPwdVal" readonly disabled></el-input>
            </el-form-item>
            <el-form-item :label="formTextConfig.newPwd">
                <el-input v-model="form.password" show-password></el-input>
            </el-form-item>
            <el-form-item :label="formTextConfig.confirmPwd" prop="confirmPwd">
                <el-input v-model="form.confirmPwd" show-password></el-input>
            </el-form-item>
            <el-form-item :label="formTextConfig.idCardNo" prop="idCardNo">
                <el-input v-model="form.idCardNo" maxlength="18" show-word-limit clearable></el-input>
            </el-form-item>
<!--            <el-form-item :label="formTextConfig.faceImg" prop="faceImg">-->
<!--                <div v-if="form.faceImg" class="face-preview">-->
<!--                    <img :src="facePreviewUrl" alt="face" class="face-img" />-->
<!--                    <div class="face-mask">-->
<!--                        <i class="el-icon-delete" @click="handleFaceRemove"></i>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <el-upload-->
<!--                v-else-->
<!--                drag action="void"-->
<!--                :limit="1"-->
<!--                name="file"-->
<!--                :before-upload="beforeAvatarUpload"-->
<!--                :http-request="uploadFile"-->
<!--                :on-progress="progressA"-->
<!--                :auto-upload="true"-->
<!--                style="padding-bottom:20px">-->
<!--            <i class="el-icon-upload"></i>-->
<!--            <div class="el-upload__text" v-html="importTextConfig.uploadText"></div>-->
<!--            <div class="el-upload__tip" slot="tip" style="text-align:center">{{importTextConfig.uploadTextTeacher}}</div>-->
<!--            <div class="el-upload__tip" slot="tip" style="text-align:center; color: #0072E0;">{{importTextConfig.uploadTextTeacher2}}</div>-->
<!--        </el-upload>-->
<!--            </el-form-item>-->
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">{{ formTextConfig.cancel }}</el-button>
            <el-button type="primary" :loading="submitLoading" @click="addUser">{{ formTextConfig.ok }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {addUser} from "@/api/user";
import request from '../../utils/request'
export default {
    data() {
        var validatePhoneOrEmail = (rule, value, callback) => {
            if (!this.form.phone && !this.form.email && !this.form.username) {
                callback(new Error(this.formTextConfig.tip1));
            } else {
                callback();
            }
        };
        return {
            dialogVisible: false,
            submitLoading: false,
            form: {
                username: null,
                realname: null,
                phone: null,
                email: null,
                password: null,
                confirmPwd: null,
                idCardNo: null,
                // faceImg: null
            },
            rules: {
                username: [
                    {min: 5, max: 20, message: '用户名长度必须介于 5 和 20 之间', trigger: 'blur'},
                    {validator: validatePhoneOrEmail, trigger: 'change'},
                    {
                        validator: function (rule, value, callback) {
                            if (/(?!^\d+$)(?!^[a-z]+$)(?!^[A-Z]+$)(?!^_+$)(^[a-zA-Z0-9\_]{5,20}$)/.test(value) === false && value) {
                                callback(new Error('支持字母（区分大小写）、数字、“_”，至少包含两种'))
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur',
                    },
                ],
                realname: [
                    {required: true, message: "姓名不能为空", trigger: "blur"},
                    {min: 2, max: 10, message: '姓名长度必须介于 2 和 20 之间', trigger: 'blur'},
                ],

                idCardNo: [
                    {
                        validator: function (rule, value, callback) {
                            if (value && !/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
                                callback(new Error('请输入正确的身份证号码'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                phone: [
                    {validator: validatePhoneOrEmail, trigger: 'change'},
                    {
                        validator: function (rule, value, callback) {
                            if (/^1[3|4|5|6|7|8|9]\d{9}$/g.test(value) === false && value) {
                                callback(new Error('请输入正确的手机号'))
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change',
                    }
                ],
                email: [
                    {validator: validatePhoneOrEmail, trigger: 'change'},
                    {type: 'email', message: '请输入正确的邮箱地址', trigger: 'change'}
                ],
                confirmPwd: [{
                    validator: (rule, value, callback) => {
                        if (this.form.password !== this.form.confirmPwd) {
                            callback(new Error('两次密码不一致'));
                        } else {
                            callback();
                        }
                    }, trigger: 'blur'
                }]
            }
        }
    },
        computed: {
            // facePreviewUrl() {
            //     return this.form.faceImg
            // },
            importTextConfig() {
            return this.$store.state.global.textConfig.backend.reviewer.button.add.import
        },
        addTextConfig() {
            return this.$store.state.global.textConfig.backend.reviewer.button.add
        },
        formTextConfig() {
            return this.addTextConfig.form
        },
    },
    methods: {
        // beforeAvatarUpload (file) {
        //     this.info = ''
        //     var testmsg = file.name.substring(file.name.lastIndexOf('.')+1)
        //     const extension = testmsg === 'jpg'
        //     const extension2 = testmsg === 'png'
        //     // 最大大小200MB
        //     const isLt2M = file.size / 1024 / 1024 < 1
        //     if(!extension && !extension2) {
        //         this.$message({
        //             message: '上传文件只能是 jpg/png格式!',
        //             type: 'warning'
        //         });
        //     }
        //     if(!isLt2M) {
        //         this.$message({
        //             message: '上传文件大小不能超过 1MB!',
        //             type: 'warning'
        //         });
        //     }
        //     return extension || extension2 && isLt2M
        // },
        //
        //  uploadFile (file) {
        //     let f = file.file
        //     let formData = new FormData();
        //     formData.append("file", f);
        //     this.http = request({
        //         url: `/api/user/add/face`,
        //         method: 'post',
        //         data: formData,
        //         //上传进度
        //         onUploadProgress: (progressEvent) => {
        //             let num = progressEvent.loaded / progressEvent.total * 100 | 0;  //百分比
        //             file.onProgress({percent: num})     //进度条
        //         }
        //     }).then(res => {
        //         file.onSuccess();
        //         this.info = ''
        //         if (res.status == 200) {
        //             this.form.faceImg = res.data
        //         }
        //         if (res.errorCode === 20009) {
        //             this.errorList = res.data
        //         }
        //     })
        // },
        //
        // handleFaceRemove() {
        //     this.form.faceImg = null
        //     this.$message({message: '已移除人脸图片', type: 'success'});
        // },



        open() {
            this.dialogVisible = true
        },
        addUser() {
            this.$refs.form.validate(vaild => {
                if (vaild) {
                    this.submitLoading = true
                    addUser(this.form).then(res => {
                        if (res.status === 200) {
                            this.$message.success('创建成功')
                            this.dialogVisible = false
                            this.$emit('success')
                            this.submitLoading = false
                        }
                    }).catch(err => {
                        this.submitLoading = false
                    })
                }
            })
        },
        reset() {
            this.form = {
                username: null,
                realname: null,
                phone: null,
                email: null,
                password: null,
                confirmPwd: null,
                idCardNo: null,
                // faceImg: null
            }
            this.$refs.form.resetFields()
        }
    }
}
</script>

<!--<style scoped>-->
<!--.face-preview {-->
<!--    position: relative;-->
<!--    display: inline-block;-->
<!--    border: 1px dashed #d9d9d9;-->
<!--    border-radius: 6px;-->
<!--    cursor: pointer;-->
<!--    overflow: hidden;-->
<!--    width: 200px;-->
<!--    height: 200px;-->
<!--}-->
<!--.face-img {-->
<!--    width: 100%;-->
<!--    height: 100%;-->
<!--    object-fit: cover;-->
<!--    display: block;-->
<!--}-->
<!--.face-mask {-->
<!--    position: absolute;-->
<!--    top: 0;-->
<!--    left: 0;-->
<!--    width: 100%;-->
<!--    height: 100%;-->
<!--    background: rgba(0, 0, 0, 0.5);-->
<!--    display: flex;-->
<!--    align-items: center;-->
<!--    justify-content: center;-->
<!--    opacity: 0;-->
<!--    transition: opacity 0.3s;-->
<!--}-->
<!--.face-preview:hover .face-mask {-->
<!--    opacity: 1;-->
<!--}-->
<!--.face-mask i {-->
<!--    color: #fff;-->
<!--    font-size: 24px;-->
<!--    cursor: pointer;-->
<!--}-->
<!--</style>-->
